import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import { Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { getTableIdentification } from "../../api/table-identification";
import { slugMap } from "../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";

export default function TableIdentification() {
  const [anchorEl, setAnchorEl] = useState(null);
  const docuRef = useRef();
  const [MemoChecked, setMemoChecked] = useState(false);
  const [docuChecked, setdocuChecked] = useState(false);
  const [statusChecked, setStatusChecked] = useState(false);
  const [yearChecked, setYearChecked] = useState(false);
  const [error, setError] = useState("");
  const open1 = Boolean(anchorEl);
  const handleClick1 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = (e) => {
    setInputSearch({})
    //  setAnchorEl(null);
  };

  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const [onInputSearch, setInputSearch] = useState({});
  const [searchInputValue, setSearchValue] = useState("");
  const [sortAscending, setSortAscending] = useState("");
  const [tablenameSearchInputValue, setTablenameSearchValue] = useState("");
  const [identitySearchInputValue, setIdentitySearchValue] = useState("");

  const params = useParams();
  //console.log(params.slug);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  useEffect(() => {
    setInputSearch({});
    setSearchValue("");
  }, [params.slug]);

  async function getTableIdentificationData(limit, offset) {
    try {
      const { data } = await getTableIdentification(user.token,
        onInputSearch
          ? {
            limit,
            offset,
            ...onInputSearch,
            sortby: sortAscending
          }
          : {
            limit,
            offset,
            sortby: sortAscending
          }
      );
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  function isStringInteger(value) {
    return (
      Number.isInteger(parseInt(value)) && value === parseInt(value).toString()
    );
  }

  const InputSearch = (event) => {
    if (isStringInteger(event.target.value) || docuChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    } else if (event.target.value.includes("/")) {
      setInputSearch({ datefrom: event.target.value });
    } else if (MemoChecked) {
      setInputSearch({ memo: event.target.value });
    }
    if (!statusChecked && !yearChecked) {
      setInputSearch({ documentno: event.target.value });
      setSearchValue(event.target.value);
    }

    if (!event.target.value.includes("-")) {
      setSearchValue(event.target.value);
    }
  };

  function onSortChanged() {
    setSortAscending((previous) => !previous);
    setTableRefreshCount((prev) => prev + 1);
  }

  const [isAsc, setIsAsc] = useState(false);
  const [isAscIden, setIsAscIden] = useState(false);

  const onSort = (column, isAscD) => {
    setSortAscending(`${column} ${isAscD}`)
    setTableRefreshCount((prev) => prev + 1);
    setIsAsc(!isAsc);
    setIsAscIden(!isAscIden);
  }

  const handleReset = (e) => {
    setInputSearch({});
    setTablenameSearchValue("");
    setIdentitySearchValue("");
  };

  const onTablenameInputSearch = (event) => {
    setTablenameSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, tablename: event.target.value });
  };

  const onIdentityInputSearch = (event) => {
    setIdentitySearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, identity: event.target.value });
  };

  const tableIdentificationTable = [
    {
      headerName: "TABLE NAME", resizable: true, headerComponent: ({ displayName, column, api }) => (
        <div onClick={() => { onSort("tablename", isAsc ? "asc" : "desc") }} className="shortingStyle">
          {displayName} {sortAscending === "" || sortAscending === "identity asc" || sortAscending === "identity desc" ? <></> : <>{isAsc ? <ArrowDownward /> : <ArrowUpward />}</>}

        </div>
      ), field: "tablename", minWidth: 120, name: "tablename"
    },
    {
      headerName: "IDENTITY", resizable: true, headerComponent: ({ displayName, column, api }) => (
        <div onClick={() => { onSort("identity", isAscIden ? "asc" : "desc") }} className="shortingStyle">
          {displayName} {sortAscending === "" || sortAscending === "tablename asc" || sortAscending === "tablename desc" ? <></> : <>{isAscIden ? <ArrowDownward /> : <ArrowUpward />}</>}
        </div>
      ), field: "identity", minWidth: 120, name: "identity"
    },
  ]

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          Table Identification
        </Typography>
        <br /><br />
        {/*  <Link to="/transaction-type">
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>*/}
      </Box>

      <Box className="filter-box">
        <Grid container spacing={{ sm: 2, md: 2 }}>
          <Grid item md={3} sm={4} xs={12}>
            <TextField
              autoComplete="off"
              size="small"
              label="Table Name"
              name={"tablename"}
              variant="outlined"
              value={tablenameSearchInputValue}
              onChange={onTablenameInputSearch}
              fullWidth
            />
          </Grid>
          <Grid item md={3} sm={4} xs={12}>
            {/* <TextField
              autoComplete="off"
              placeholder={"Identity"}
              size="small"
              label=""
              name={"identity"}
              variant="outlined"
              value={identitySearchInputValue}
              onChange={onIdentityInputSearch}
              fullWidth
            /> */}
            <TextField style={{ backgroundColor: "#FFF" }}
              id="outlined-select-currency"
              value={identitySearchInputValue}
              select
              label="Identity"
              fullWidth
              onChange={onIdentityInputSearch}
              size="small"
              className="identityStyle"
            >
              <MenuItem className="identityDropDown" value="DERIVED">DERIVED</MenuItem>
              <MenuItem className="identityDropDown" value="LISTS">LISTS</MenuItem>
              <MenuItem className="identityDropDown" value="RAW">RAW</MenuItem>
              <MenuItem className="identityDropDown" value="REPORT">REPORT</MenuItem>
              <MenuItem className="identityDropDown" value="SAVED SEARCH">SAVED SEARCH</MenuItem>
            </TextField>
          </Grid>
          <Grid item md={2} sm={2} xs={2}>
            <Button
              size="small"
              type="button"
              style={{ color: "black", marginTop: "4px" }}
              onClick={(e) => handleReset(e)}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Paper sx={{ border: "1px solid #1615131a;" }}>
        <AgGridPaginatedTable
          getTableRows={getTableIdentificationData}
          columns={tableIdentificationTable}
          perPage={20}
          onSortChanged={onSortChanged}
          refreshCounter={tableRefreshCount}
          onInputSearch={onInputSearch}

        />
      </Paper>
    </>
  );
}
